"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.dropContainerName = exports.keySplit = exports.hiddenStyleList = void 0;
/** @ignore */
exports.hiddenStyleList = "\n  display: none !important;\n  width: 1px !important;\n  height: 1px !important;\n  position: fixed !important;\n  z-index: -99 !important;\n  bottom: 0px !important;\n  right: 0px !important;\n";
/** @ignore */
exports.keySplit = '-*ASPGTW*-';
/** @ignore */
exports.dropContainerName = 'http-dropzone-container';
